import { render, staticRenderFns } from "./TeamEffectivenessWizardModal.vue?vue&type=template&id=6c575d71&scoped=true"
import script from "./TeamEffectivenessWizardModal.vue?vue&type=script&lang=ts"
export * from "./TeamEffectivenessWizardModal.vue?vue&type=script&lang=ts"
import style0 from "./TeamEffectivenessWizardModal.vue?vue&type=style&index=0&id=6c575d71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c575d71",
  null
  
)

export default component.exports